import { wpFetch } from 'src/helpers/wpApiHandler';

export const updateStatusOnServer = async (leadId, companyId, status, recruiterId) => {
  try {
    await wpFetch(['status'], {
      method: 'POST',
      body: {
        lead_id: leadId,
        company_id: companyId,
        status,
        recruiter_id: recruiterId,
      },
    });
  } catch (error) {
    throw new Error(error?.message || 'An error happened while updating status');
  }
};

export const saveNoteOnServer = async (leadID, companyID, noteText, recruiterId) => {
  try {
    const data = await wpFetch(['note'], {
      method: 'POST',
      body: {
        lead_id: leadID,
        company_id: companyID,
        note: noteText,
        recruiter_id: recruiterId,
      },
    });

    return data;
  } catch (error) {
    throw new Error(error?.message || 'An error happened while saving note');
  }
};

export const handleNoteAfterSave = async (leadID, companyID, noteText) => {
  try {
    await wpFetch(['note-notify'], {
      method: 'POST',
      body: {
        lead_id: leadID,
        company_id: companyID,
        note: noteText,
      },
    });
  } catch (error) {
    throw new Error(error?.message || 'An error happened when notifying about note');
  }
};

export const updateNoteOnServer = async (leadID, companyID, noteID, noteText, recruiterId) => {
  try {
    await wpFetch(['note'], {
      method: 'PUT',
      body: {
        note_id: noteID,
        lead_id: leadID,
        company_id: companyID,
        note: noteText,
        recruiter_id: recruiterId,
      },
    });
  } catch (error) {
    throw new Error(error?.message || 'An error happened while updating note');
  }
};

export const handleNoteAfterUpdate = async (leadID, companyID, noteText) => {
  try {
    await wpFetch(['note-notify'], {
      method: 'PUT',
      body: {
        lead_id: leadID,
        company_id: companyID,
        note: noteText,
      },
    });
  } catch (error) {
    throw new Error(error?.message || 'An error happened when notifying about updated note');
  }
};

export const deleteNoteOnServer = async (noteID, leadID, companyID, recruiterId) => {
  try {
    await wpFetch(['note'], {
      method: 'DELETE',
      body: {
        note_id: noteID,
        lead_id: leadID,
        company_id: companyID,
        recruiter_id: recruiterId,
      },
    });
  } catch (error) {
    console.error('Error with the request', error);
    throw new Error(error?.message || 'An error happened while deleting note');
  }
};
